<div class="radioBtn-container mt-2">
    <h2 mat-dialog-title *ngIf="title">
        {{title}}
    </h2>

    <form class="forms" [formGroup]="cameraGrp">
        <mat-radio-group formControlName="options">
            <mat-radio-button class="radioBtn" [value]="item" *ngFor="let item of cameraValues">{{item.label}}
            </mat-radio-button>
        </mat-radio-group>
    </form>

    <div mat-dialog-actions [ngClass]="{'justify-content-end' : actionsToRight, 'justify-content-start' : !actionsToRight}">
        <button [ngClass]="{'order-1 ml-2': confirmToRight, 'order-0': !confirmToRight}" mat-button color="primary" (click)="onConfirm()" style="color: var(--bs-primary) !important;">Yes</button>
        <button mat-button color="warn" (click)="onDismiss()">No</button>
    </div>
</div>